import { render, staticRenderFns } from "./CommentSummary.vue?vue&type=template&id=c4429a2e&scoped=true&"
import script from "./CommentSummary.vue?vue&type=script&lang=js&"
export * from "./CommentSummary.vue?vue&type=script&lang=js&"
import style0 from "./CommentSummary.vue?vue&type=style&index=0&id=c4429a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4429a2e",
  null
  
)

export default component.exports